/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import { gt } from '@ember/object/computed';
import Component from '@glimmer/component';
import { isNone } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import GroupCondition from 'cio/app-models/conditions/group';
import { deserializeFilters, filterOperator } from 'cio/utils/conditions/deserialize/event';
import { SerializedLegacyAttributeFilters } from 'cio/types/conditions/legacy-filter';

interface CioCampaignEventTriggerArgs {
  event: string;
  attributeFilters: SerializedLegacyAttributeFilters;
  canSendOneTimeEvent: boolean;
  restartMinInterval: boolean;
}

function deserializeAttributeFilters(filters: SerializedLegacyAttributeFilters, event: string) {
  if (isNone(filters)) {
    return GroupCondition.create({ operator: 'and' });
  }

  return GroupCondition.create({
    operator: filterOperator(filters),
    children: deserializeFilters(filters, event),
  });
}

export default class CioCampaignEventTrigger extends Component<CioCampaignEventTriggerArgs> {
  @tracked isShowingSendTestEventModal = false;

  @gt('filters.children.length', 0) gotFilters!: boolean;

  @computed('args.attributeFilters')
  get filters() {
    return deserializeAttributeFilters(this.args.attributeFilters, this.args.event);
  }
}
